@use '../../../scss/settings/colors';

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -61px 0 38px;

  h1 {
    margin-bottom: 8px;
    color: colors.$dark-blue;
    font-size: 26px;
    line-height: 150%;
  }
}

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: colors.$gray-variant-16;

  .documentViewText {
    text-decoration-color: colors.$brand-purple;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 6px;
    font-size: 14px;
  }

  h3 {
    font-size: 15px;
    line-height: 24px;
    cursor: pointer;
  }

  a, h3 {
    text-decoration: underline;
    color: colors.$brand-purple;

    &:hover {
      text-decoration: none;
    }

  }

}

.separator {
  color: colors.$gray-variant-16;
}

.gridItem {
  position: relative;
  background: colors.$base-white;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  padding: 12px 16px 8px;
  // height: 100%;
}

.gridItemBoxShadow {
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.tabs {
  height: 40px;
  display: flex;
  align-items: center;

  .tab {
    padding: 0 16px;
    text-transform: none;
    color: colors.$gray-variant-16;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 120px;

    &:hover {
      color: colors.$brand-purple;
    }

    &.activeTab {
      color: colors.$brand-purple;
    }
  }
}

.tabContent {
  // min-height: calc(100vh - 200px);
}

.mainContent {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  //align-items: center;
  height: 100%;
  padding: 0;

  .main_container {
    height: 100%;
    //overflow: auto;
    flex-grow: 1;

    &.w_55 {
      max-width: 65% !important;
    }

  }

}

.title {
  margin-bottom: 0;
  font-size: 16px !important;
  color: colors.$dark-blue;
}

.labels_row {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  //height: 35px;
  font-family: 'Regular Inter', sans-serif;
  font-size: 14px;
  color: colors.$dark-blue;
}

.card_border {
  border: 1px solid colors.$brand-purple;
  animation: pulse 0.4s ease-in-out;
}

.copymodal {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 50% !important;
  top: 0 !important;
  left: 25% !important;
  margin: 0;
  padding: 0;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}



